import { render, staticRenderFns } from "./RadioButtonList.vue?vue&type=template&id=4890bf04&scoped=true"
import script from "./RadioButtonList.vue?vue&type=script&lang=js"
export * from "./RadioButtonList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4890bf04",
  null
  
)

export default component.exports